import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { change } from 'redux-form';
import _get from 'lodash/get';
import { callSelectors, chatActions, chatSelectors } from '@lifesize/nucleus';
import {
  setChatMode,
  setFormFocus,
  selectConversationContactDialString
} from 'actions/Chat';
import { endRouteLoading } from 'actions/SideNav';
import Chat from 'components/Chat/Chat';
import {
  CHAT_SEARCH_FORM
} from 'constants/Chat';
import {
  currentConversationDialStringSelector
} from 'selectors/chat';
import { isCallConnected } from 'utils/call-utils';

function mapDispatchToProps(dispatch) {
  return {
    onLeaveConversation: contact => dispatch(chatActions.leaveConversation(contact)),
    onSelectContact: (contact, autoSelect = false) => {
      if (contact) {
        dispatch(setChatMode());
        dispatch(chatActions.enterConversation(contact));
        dispatch(selectConversationContactDialString(_get(contact, 'dialString')));
        dispatch(change(CHAT_SEARCH_FORM, 'chatSearchBar', ''));
        setFormFocus(false);
      } else if (!autoSelect) {
        dispatch(setChatMode('search'));
      }
    },
    onSelectConversation: (conversation) => {
      dispatch(setChatMode());
      dispatch(chatActions.enterConversation({ uuid: _get(conversation, 'conversationId') }));
      dispatch(selectConversationContactDialString(_get(conversation, 'contact.dialString')));
      dispatch(chatActions.markConversationMessagesAsRead(_get(conversation,'contact')));
    },
    markConversationAsRead: (conversation) => {
      if (!document.hidden) {
        dispatch(chatActions.markConversationMessagesAsRead(_get(conversation, 'contact')));
      }
    },
    onSetChatMode: (mode, contact) => {
      dispatch(setChatMode(mode, contact));
    },
    endRouteLoading: () => dispatch(endRouteLoading())
  };
}

function mapStateToProps(state) {
  const conversationMode = _get(state, 'app.chat.conversationMode');
  const conversations = chatSelectors.groupedConversations(state);
  const meetingConversations = conversations.meetingConversations || [];
  const userConversations = conversations.userConversations || [];
  const conversationContactDialString = currentConversationDialStringSelector(state);
  const conversation = chatSelectors.getChatForWebGenerator(state)(conversationContactDialString);
  const isFirstUse = !meetingConversations.length && !userConversations.length;
  const activeCall = callSelectors.activeCallSelector(state);
  const hiddenByCall = isCallConnected(activeCall) && !_get(state, 'app.inCallVideo.isMinimized');

  return {
    hiddenByCall,
    conversations,
    conversation,
    conversationContactDialString,
    conversationMode,
    isFirstUse
  };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Chat));
